<main class="main">
  <div class="main-content">
    <!-- Titolo e sottotitolo -->
    <div class="settings-header">
      <div class="settings-heading-icon"><i class="fas fa-gear"></i></div>
      <div>
        <h1 class="main-title">{{ 'SETTINGS.TITLE' | translate }}</h1>
        <p class="main-subtitle">{{ 'SETTINGS.SUBTITLE' | translate }}</p>
      </div>
    </div>

    <div class="settings-content">
      <!-- Pulizia dati locali (cookie + storage) con logout: stessa sezione di /tos -->
      <section class="settings-card settings-card--danger" id="clear-data">
        <h3 class="card-title">
          <span class="card-title-icon card-title-icon--danger"><i class="fas fa-broom"></i></span>
          {{ 'TOS.CLEAR_DATA.TITLE' | translate }}
        </h3>
        <p class="card-description">{{ 'TOS.CLEAR_DATA.DESCRIPTION' | translate }}</p>
        <p *ngIf="isLoggedIn" class="settings-note">
          <i class="fas fa-triangle-exclamation"></i>
          {{ 'TOS.CLEAR_DATA.LOGOUT_NOTE' | translate }}
        </p>
        <button type="button" class="btn-clear-data" (click)="clearLocalData()" [disabled]="isClearing">
          <i class="fas" [ngClass]="isClearing ? 'fa-spinner fa-spin' : (isLoggedIn ? 'fa-right-from-bracket' : 'fa-broom')"></i>
          {{ (isClearing ? 'TOS.CLEAR_DATA.IN_PROGRESS' : (isLoggedIn ? 'TOS.CLEAR_DATA.BUTTON_LOGOUT' : 'TOS.CLEAR_DATA.BUTTON')) | translate }}
        </button>
      </section>
    </div>
  </div>
</main>
